import React from 'react';
import { Grid, Tooltip, IconButton, Typography } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DownloadIcon from '@mui/icons-material/Download';

const FileUploadWithPreview = ({ 
  label, 
  accept = "application/pdf,image/*", 
  onDownload, 
  onFileChange, // <-- callback to parent
  downloadTooltip = "Download Document" 
}) => {

  const handleFileChange = (file) => {
    if (!file) return;

    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const base64String = reader.result.split(',')[1];
      // Send both file name and base64 to parent
      onFileChange({ base64: base64String, fileName: file.name });
    };
  };

  return (
    <>
      {/* Upload & Download Buttons */}
      <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>
        <Tooltip title={`Upload ${label}`}>
          <IconButton color="secondary" component="label">
            <CloudUploadIcon />
            <input
              type="file"
              hidden
              accept={accept}
              onChange={(e) => handleFileChange(e.target.files[0])}
            />
          </IconButton>
        </Tooltip>

        <Tooltip title={downloadTooltip}>
          <IconButton
            color="secondary"
            onClick={onDownload}
          >
            <DownloadIcon />
          </IconButton>
        </Tooltip>
      </Grid>

      {/* File name display handled by parent */}
    </>
  );
};

export default FileUploadWithPreview;
